import { createSlice } from "@reduxjs/toolkit";
import { getCookie, setCookie } from "../../../utils/storage";

const initialState = {
  properties: getCookie("properties")
    ? JSON.parse(getCookie("properties"))
    : [],
  selectedProperties: getCookie("selectedProperties")
    ? JSON.parse(getCookie("selectedProperties"))
    : [],
  singleSelectedProperty: getCookie("singleSelectedProperty")
    ? getCookie("singleSelectedProperty")
    : null,
};

export const propertiesSlice = createSlice({
  name: "properties",
  initialState,
  reducers: {
    addProperties: (state, { payload }) => {
      state.properties = payload;
      setCookie("properties", payload);

      if (payload?.length >= 1 && state.selectedProperties?.length === 0) {
        state.selectedProperties = [payload[0]?.id];
        setCookie("selectedProperties", [payload[0]?.id]);
      }
    },
    setSelectedProperties: (state, { payload }) => {
      state.selectedProperties = payload;
      setCookie("selectedProperties", payload);
    },
    setSingleSelectedProperty: (state, { payload }) => {
      state.singleSelectedProperty = payload;
      setCookie("singleSelectedProperty", payload);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addProperties,
  setSelectedProperties,
  setSingleSelectedProperty,
} = propertiesSlice.actions;

export default propertiesSlice.reducer;
